import { HtmlStringSanitiser } from "@pjs/security";

export const ngHtmlStringSanitiser = HtmlStringSanitiser.createFromExtendedDefaults({ additionalAttributes: ["target", "controls", "autoplay"], forbiddenTags: ["form"] });
